import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ApiAddResponse } from 'src/app/interfaces/api';
import { UniService } from 'src/app/services/uni.service';
import { University } from '../../models/university.model';

@Component({
    selector: 'app-uni-add',
    templateUrl: './uni-add.component.html',
    styleUrls: ['./uni-add.component.scss'],
})
export class UniAddComponent {
  @Input() public prefill = '';

  @Output() private readonly uniAdded = new EventEmitter<University>();

  @ViewChild('uniName') public readonly uniName!: ElementRef;

  public adding = false;

  constructor(public readonly uniService: UniService) {}

  public addUni(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    const uni = new University();
    const nameElement = <HTMLInputElement>this.uniName.nativeElement;
    uni.name = nameElement.value;
    uni.searchableName = uni.name.toLowerCase();
    this.adding = true;

    this.uniService.createUniversity(uni).subscribe({
      next: (addedUni) => {
        const uniResponse = <ApiAddResponse>addedUni;
        this.uniAdded.emit(<University>uniResponse.data);
        this.adding = false;
      },
      error: () => {
        this.adding = false;
      },
    });
  }
}
